export enum InstalledStateEnum {
 StateDraft       = 'draft',
 StateRecommended = 'recommended',
 StateInstalled   = 'installed',
 StateRemoved     = 'removed',
}
